import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';


function ArtistUpload() {
  const [files, setUpload] = useState([]);
  const [artistName, setArtistName] = useState('');
  const [email, setEmail] = useState('');
  const [coverArt, setCoverArt] = useState(null);
  const [alertEmail, setAlertEmail] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const navigate = useNavigate();

  // upload function
async function upload(files, coverArt) {
  // Normalize
  files = Array.from(files || []);
  if (!files.length) {
    console.error("No files received by upload");
    return;
  }

  const params = files
    .map(f => `filename=${encodeURIComponent(f.name)}`)
    .join("&");

  const url = `http://localhost:8080/uploadv2?email=${encodeURIComponent(email)}&artistName=${artistName}&${params}&coverArt=${coverArt.name}`;

  // GET signed URLs from /uploadv2 instead of POST
  const r = await fetch(url); // 
  const data = await r.json();
  const signedUrls = data.signedUrls; 
  console.log("data processing...");
  // Upload raw binary files to signed URLs
  for (let i = 0; i < files.length; i++) {
    await fetch(signedUrls[i], {
      method: "PUT",
      body: files[i],
      headers: { "Content-Type": files[i].type }
    });
  }

}


// perform upload
async function fetchData() {
  try {
    setUploaded(true);
    await upload(files, coverArt);   
  } catch (err) {
    console.log(err);
  } finally {
    setUploaded(false);
  }
}

  // validate then perform upload
  function handleSubmit(e) {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email.trim() === '') {
      console.log('email is blank')
      setAlertEmail(true);
      return true; // stop submission
    } else if (emailRegex.test(email) === false){ 
      console.log('email is not in proper format');
      setAlertEmail(false);
      return false;
    } else {
      setAlertEmail(null);
      
    }
    fetchData();
  
  }
  return (
    uploaded ? <UploadingSongs/> : 
    <div className='upload'>
          <h1>  Artists, are you tired of making .0003 per stream?</h1>
          <p>With MP3Juug you can DIY: Distribute it yourself.</p>
          <h2 style={{textAlign:'center'}}><b>Instructions:</b></h2>
          <ol>
            <li>Enter your     <input
              type="text"
              placeholder="artist name"
              value={artistName}
              onChange={(e) => setArtistName(e.target.value)}
            /></li>
            <li>Enter your     <input
              type="text"
              placeholder="artist upload email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {
              alertEmail === true ? (
               <span style={{ color: 'red', marginLeft: '10px', marginRight: '10px', fontSize: '12px' }}>
                Please enter your email address to use for uploads.
              </span>
              ): alertEmail === false ? (
                <span style={{ color: 'red', marginLeft: '10px', marginRight: '10px', fontSize: '12px' }}>
                Please enter an email address with proper format. i.e. <b>artist@example.com</b>
              </span>
              ): alertEmail === null ? <></>: <></>
            }</li>
            <li>Upload your .wav or mp3 music files: <input
              type="file"
              multiple
              onChange={(e) => setUpload(e.target.files)}
            /> </li>
             <li>Upload cover art: <input
              type="file"
              onChange={(e) => setCoverArt(e.target.files[0])}
            /> </li>
            <li><button onClick={handleSubmit}>Upload</button></li>
            <li><button onClick={
              () => {navigate('/link');}} style={{fontSize: '20px'}
              }>Get your download links now</button> to place on physical media.</li>
          </ol>     
    </div>
);
}

function UploadingSongs() {
  return (
    <>
      <p>UPLOADING UR MUSIC..</p>
    </>
  );
}

export default ArtistUpload;
